/* AD code dropdown (company banks) with "+ Add new AD code…" — used by EDF + PB forms. */
import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, getAuthHeader } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const EMPTY = { name: "", ad_code: "", address: "" };

export const BankSelect = ({ companyId, companyName, banks, value, disabled, onPick, onAdded, testid }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/edf-doc/banks/${companyId}`, f, { headers: getAuthHeader() });
      toast.success(`AD code ${r.data.ad_code} added to ${companyName || "company"}`);
      setF(EMPTY); setOpen(false); onAdded(r.data); onPick(r.data.id);
    } catch (e) { toast.error(e.response?.data?.detail || "Could not add AD code"); }
    setBusy(false);
  };
  return (
    <>
      <select value={value || ""} disabled={disabled || !companyId}
        onChange={(e) => (e.target.value === "__add" ? setOpen(true) : onPick(e.target.value))}
        className="h-7 w-56 rounded border px-1 text-xs" data-testid={testid}>
        <option value="">— AD code —</option>
        {banks.map(b => <option key={b.id} value={b.id}>{b.ad_code} · {b.name}</option>)}
        <option value="__add">+ Add new AD code…</option>
      </select>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="bank-add-dialog">
          <DialogHeader><DialogTitle className="text-base">New AD code · {companyName}</DialogTitle></DialogHeader>
          <Input placeholder="Bank name (e.g. AXIS BANK)" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="bank-add-name" />
          <Input placeholder="AD code (e.g. 6360286)" value={f.ad_code} onChange={(e) => setF({ ...f, ad_code: e.target.value })} data-testid="bank-add-adcode" />
          <Input placeholder="Branch address (optional)" value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} data-testid="bank-add-address" />
          <Button onClick={save} disabled={busy || !f.name.trim() || !f.ad_code.trim()} data-testid="bank-add-save">Add AD code</Button>
        </DialogContent>
      </Dialog>
    </>
  );
};
